import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import i18next from 'i18next';

import {Layout, ListItem, Select, Text, TextArea, TextField} from '@phonectas/unifon-ui-kit';
// import {StyledCompactTextField} from 'common/styled';
import TextWithLabel from 'common/components/TextWithLabel';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {ConfigTemplate, CustomerUser} from 'common/types/store/threeSixtyTypes';

interface ReportErrorContentProps {
	formData: {
		category: string;
		country: string;
		description: string;
		user_id: string;
	}
	onChange: (name: string, value: string) => void;
	data?: CustomerUser;
}

const ReportErrorContent: React.FC<ReportErrorContentProps> = ({
	formData,
	onChange,
	data,
}) => {
	const [t] = useTranslation();
	const options = useThreeSixtyNewStore((state) => state.configTemplates);
	const handleChange = useCallback(
		(name: string, value: string | number | string[] | number[] | undefined) => {
			let stringValue = '';
			if (typeof value === 'string' || typeof value === 'number') {
				stringValue = value.toString();
			}
			onChange(name, stringValue);
		},
		[onChange]
	);

	return (
		<Layout fullWidth nowrap direction="row" gap="md">
			<Layout direction="column" gap="md" style={{width: '500px'}}>
				<Text>{t('Please describe the incident')}</Text>
				<TextWithLabel label={t('Customer')} text={data?.name || ''}/>
				<Layout direction="row" gap="xs" nowrap fullWidth>
					<Select
						label={t('Category')}
						fullWidth
						placeholder={t('Select')}
						value={formData.category}
						name="category"
						onChange={(value) => handleChange('category', value ?? '')}
					>
						{(Array.isArray(options) ? options : []).map((option: ConfigTemplate) => (
							<ListItem
								key={option.id}
								value={option.content}
								primaryText={
									i18next.language === 'en'
										? option.lang?.[0]?.en ?? ''
										: option.lang?.[0]?.no ?? ''
								}
								selected={formData.category === option.content}
							/>
						))}
					</Select>
					<TextField
						label={t('Country')}
						value={formData.country}
						onChange={(e) => handleChange('country', e.target.value)}
						fullWidth
						name="country"
					/>
				</Layout>
				<Layout direction="row" gap="xs" nowrap fullWidth>
					<TextArea
						style={{height: '150px'}}
						onChange={(e) => handleChange('description', e.target.value)}
						label={t('Description')}
						value={formData.description}
						fullWidth
						name="description"
					/>
				</Layout>
			</Layout>
			{/* <Divider vertical />
			<Layout direction="column" gap="xs" style={{width: '400px'}}>
				<Text>{t('User')}</Text>
				<StyledCompactTextField fullWidth label={t('Name')} value={data?.name}/>
			</Layout> */}
		</Layout>
	);
}

export default ReportErrorContent;
